import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateBloggerModal from "../admin/Components/CreateBloggerModal";
import { Table, Spinner } from "react-bootstrap";
import { useAlert } from "../admin/context/AlertContext";

const BlogHeadUsers = () => {
  const navigate = useNavigate();
  const [showBloggerModal, setShowBloggerModal] = useState(false);
  // const [adminName, setAdminName] = useState("Pratika");

  const handleShowBlogger = () => setShowBloggerModal(true);
  const handleCloseBlogger = () => setShowBloggerModal(false);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_HOST = process.env.REACT_APP_API_URL;
  const authToken = sessionStorage.getItem("authToken");
  const showAlert = useAlert();


 

  useEffect(() => {
    // If authToken exists in session storage, redirect to the admin dashboard
    if (sessionStorage.getItem("authToken")) {
      const userType = sessionStorage.getItem("userType");
      if (userType === "blogger") {
        navigate("/blogger");
      } else if (userType === "admin") {
        navigate("/admin");
      } else if (userType === "blogHead") {
        fetchUsers();
        return;
      }
    }
  }, [navigate]);

const fetchUsers = async () => {
  try {
    console.log("passing authToken", authToken);
    const response = await fetch(`${API_HOST}auth/blogusers`, {
      method: "GET",
      headers: {
        "auth-token": authToken,
      },
    });

    if (!response.ok) throw new Error("Failed to fetch users");

    const data = await response.json();
    const filteredUsers = data.filter(user => user.userType !== "admin");  
    setUsers(filteredUsers);
  } catch (error) {
    showAlert(error.message, "danger");
  } finally {
    setLoading(false);
  }
};


  const deleteUser = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      const response = await fetch(`${API_HOST}auth/users/${id}`, {
        method: "DELETE",
        headers: {
          "auth-token": authToken,
        },
      });

      const result = await response.json();

      if (!response.ok)
        throw new Error(result.error || "Failed to delete user");

      showAlert("User deleted successfully", "success");
      setUsers(users.filter((user) => user._id !== id));
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  // useEffect(() => {
  //   fetchUsers();
  // }, []);

  if (loading) {
    return (
      <div className="text-center p-4">
        <Spinner animation="border" variant="light" />
        <p className="text-white">Loading users...</p>
      </div>
    );
  }

  return (
    <>
      <div className="admin-dashboard-container container">
        <div className="dashboard-header">
          {/* <h1>Welcome, {adminName}</h1> */}
          
          
         

          <div
            className="flex justify-content-between"
            style={{
              padding: "8px",
              display: "flex",
              gap: "10px",
            }}
          >
            {/* <button
              className="logout-button"
              onClick={() => {
                navigate("/blogHead");
              }}
            >
              Admin Home
            </button> */}

            <button className="logout-button" onClick={handleShowBlogger}>
              Create Blogger
            </button>

            <button
              onClick={() => {
                sessionStorage.removeItem("authToken");
                navigate("/blogHead/login");
              }}
              className="logout-button"
            >
              Logout
            </button>
          </div>
        </div>

        <div className="container mt-4 bg-dark text-white p-4 rounded shadow">
          <h2 className="mb-4">All Users</h2>
          <Table striped bordered hover variant="dark" responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>User Type</th>
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {users.map((u, index) => (
                <tr key={u._id}>
                  <td>{index + 1}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.userType}</td>
                  {/* <td>
                    {u.userType !== "admin" || u.userType !== "blogHead" ? (
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => deleteUser(u._id)}
                      >
                        Delete
                      </Button>
                    ) : (
                      <span className="text-muted">Protected</span>
                    )}
                  </td> */}
                  
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <CreateBloggerModal
        showModal={showBloggerModal}
        handleClose={handleCloseBlogger}
        forBlogHead={true}
      />
    </>
  );
};

export default BlogHeadUsers;
